import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { filter, map, switchMap } from 'rxjs';
import { SnackbarService, WindowService } from '@nx-customer-apps/shared/services';
import { FooterComponent } from './core/components/footer/footer.component';
import { ContentComponent } from './core/components/content/content.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet, TranslateModule, FooterComponent, ContentComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
    private translateService = inject(TranslateService);
    private snackbarService = inject(SnackbarService);
    private swUpdate = inject(SwUpdate);
    private windowService = inject(WindowService);

    ngOnInit(): void {
        this.checkForNewVersion();
        this.translateService.use('en-DE');
    }

    private checkForNewVersion(): void {
        if (this.swUpdate.isEnabled) {
            this.swUpdate.checkForUpdate();
            this.swUpdate.versionUpdates
                .pipe(
                    filter(versionEvent => versionEvent.type === 'VERSION_READY'),
                    switchMap(() => this.translateService.get(['PTC.NEW_VERSION', 'PTC.BUTTON.RELOAD'])),
                    map(keys => ({
                        message: keys['PTC.NEW_VERSION'],
                        action: keys['PTC.BUTTON.RELOAD']
                    })),
                    switchMap(({ message, action }) =>
                        this.snackbarService
                            .showInfo(message, {
                                duration: 0,
                                action,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            })
                            .onAction()
                    )
                )
                .subscribe(() => {
                    this.windowService.nativeWindow.location.reload();
                });
        }
    }
}
